export default {
  'get-list': {
    method: 'post',
    url: '/p/vehicle/insurance/list'
  },
  add: {
    method: 'post',
    url: '/p/vehicle/insurance'
  },
  update: {
    method: 'put',
    url: '/p/vehicle/insurance/ID'
  },
  delete: {
    method: 'delete',
    url: '/p/vehicle/insurance'
  }
}
